import { uniq } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	documentIds: [],
	files: [],
	uploadErrors: [],
};

const reducerMap = {
	[types.ADD_DOCUMENT_ID]: (state, { payload }) => {
		return {
			...state,
			documentIds: uniq(state.documentIds.concat(payload.id)),
		};
	},
	[types.REMOVE_DOCUMENT_ID]: (state, { payload }) => {
		return {
			...state,
			documentIds: state.documentIds.filter((id) => id !== payload.id),
		};
	},
	[types.SET_FILES]: (state, { payload }) => {
		return {
			...state,
			files: payload.files,
			uploadErrors: [],
		};
	},
	[types.RESET_DOCUMENTS]: (state) => {
		return {
			...state,
			documentIds: [],
		};
	},
	[types.SET_UPLOAD_ERRORS]: (state, { payload }) => {
		return {
			...state,
			uploadErrors: payload.errors,
		};
	},
};

export default handleActions(reducerMap, initialState);
